export * from './solicitacoes-pendentes-controller';
export * from './solicitacoes-pendentes-detalhes-controller';
export * from './solicitacoes-pendentes-informar-parecer';
export * from './solicitacoes-pendentes-historicos';
